module.exports = __webpack_public_path__ + "static/media/picture-(91).4ae45b77.JPG";